export class ProductCreateUpdateDto {

  id: number = 0;
  country: string = '';
  statusCode: number = 0;
  userId: string = '';
  name: string = '';
  description: string = '';
  visit?: number = 0;
  rateCurveId: number = 0;
  productCode: string = '';
  accountCode: string | null = null;
  actionCode: string | null = null;
  coverageCode: string | null = null;
  insuranceCode: string = '';
  details?: string = '';
  productName: string = '';
  csId: string = '';
  createDate?: string = '';
  productDescription: string = '';
  account: string | null = null;
  invoiceMonths?: number = 0;
  productDetails: string = '';
  operation: string = '';
  version: number = 0;
  dateStart: string = '';
  dateEnd: string = '';
  cost: number = 0;
  sellerPrice: number = 0;
  customerPrice: number = 0;
  months?: number = 0;
  kilometers?: number = 0;
  planYear: number = 0;

}